define('modules/emblue/index',['require','exports','module','./router','./model'],function (require, exports, module) {
  "use strict";

  var Router = require("./router");
  var Model = require("./model");

  module.exports = {
    init: function () {
      new Router();
    },
    Model: Model,
  };
});

